import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackgroundComponent } from './background.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@NgModule({
  declarations: [BackgroundComponent],
  imports: [CommonModule, NzSpinModule],
  exports: [BackgroundComponent],
})
export class BackgroundModule {}
